"use client";
import type { ReactElement } from "react";
import { cn } from "@/lib/cn";

type Props = {
  /**
   * AE-authored free text. `""` is the unset marker on the public booking
   * endpoint and `undefined` is what a pre-kris-backend#9713 deployment sends;
   * both mean "the AE wrote none", and neither may render an empty box.
   */
  description: string | undefined;
  className?: string;
};

export function MeetingAgenda({
  description,
  className,
}: Props): ReactElement | null {
  const text = description?.trim();
  if (!text) return null;

  return (
    <div
      className={cn(
        "mb-6 rounded-xl border border-[#d0f0ef] bg-[#E8F9F9] px-4 py-3.5",
        className
      )}
    >
      <p className="text-xs font-semibold uppercase tracking-widest text-neutral-400">
        Agenda
      </p>
      {/*
        Rendered as a JSX text child, never dangerouslySetInnerHTML: this is
        free text an AE typed, it reaches a public page no lead has any trust
        relationship with, and markup in it must show as the characters the AE
        typed. `whitespace-pre-line` keeps their line breaks without parsing.
      */}
      <p className="mt-1.5 whitespace-pre-line text-sm leading-relaxed text-neutral-700">
        {text}
      </p>
    </div>
  );
}
